import {reservation_status} from "@/utils/mockup";
import {guestReservationsService} from "@/services/guest/reservations/reservations.service";
import {alertService} from "@/services/alert/alert.service";
import Show from "/src/resources/views/guest/reservations/show.component.vue";
import Cancel from "/src/resources/views/guest/reservations/cancel.component.vue";

export default {
    components: {
        Show,
        Cancel
    },
    filters: {
        // 00:00:00を00:00に変更するフィルター
        timeShorten: function(value) {
            if (!value) return '';
            return value.slice(0, 5);
        },
        // 2000-01-01 → 1月1日（土）変換
        formatDate: function(dateString) {
            const date = new Date(dateString);
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
            const dayOfWeek = daysOfWeek[date.getDay()];
            return `${month}月${day}日（${dayOfWeek}）`;
        },
    },
    data: () => {
        return {
            tab: null, // 予約情報のメニュータブ
            showValue: null, // showに表示する情報
            showReady: false, // show画面推移
            cancelValue: null, // cancel画面に表示する情報
            cancelReady: false, // cancel画面推移
            updateShowFlg: false, // Pageがアップデートを行う画面かの判断
            cancelShowFlg: true, // Pageがキャンセルボタンを表示させるか
            receiptShowFlg: false, // Pageが領収書ボタンを表示させるか
            reservedFee: 0, // 予約済みの金額
            refundFee: 0, // 返金金額
            confirm: {}, // 予約済み
            confirmReady: false,
            // entered: {}, // 入庫済み(使われてない)
            // enteredReady: false,
            // exited: {}, // 出庫済み(使われてない)
            // exitedReady: false,
            cancelled: {}, // キャンセル済み
            cancelledReady: false,
            history: {}, // 利用履歴
            historyReady: false,
            reservation: {},
            reservation_status: reservation_status,
            filter: {
                page: 1
            },
            api_url: process.env.VUE_APP_API_URL,
        }
    },
    async mounted() {
        // クエリパラメータからタブを設定
        if (this.$route.query.tab) {
            this.tab = Number(this.$route.query.tab);
        } else {
            this.tab = 0; // デフォルトのタブ
        }
        this.confirmList()
        this.historyList()
        // this.enteredList()
        // this.exitedList()
        this.cancelledList()
    },
    methods: {
        vTabEvent(){
            this.showReady = false;
            this.cancelReady = false;
        },
        // 詳細表示を閉じる
        closedShowPage(){
            this.showReady = false;
            this.$nextTick(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        },
        // 詳細表示を開く
        opendShowPage(value, flg1, flg2){
            this.closedCancelPage();
            this.updateShowFlg = flg1;
            this.cancelShowFlg = new Date(value.entry_date) >= new Date();
            this.receiptShowFlg = flg2;
            this.showValue = value;
            this.showReady = true;
            this.$nextTick(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        },
        // キャンセル画面を開く
        async opendCancelPage(value){
            await guestReservationsService.getCancelFee({
                reservation_id: value.id,
                entry_date: value.entry_date,
            }).then((response) => {
                this.reservedFee = 0;
                this.refundFee = 0;
                this.reservedFee = response.data.reserved_fee; // 予約済みの金額
                this.refundFee =  response.data.refund_fee; // 返金金額
                this.closedShowPage();
                this.cancelValue = value;
                this.cancelReady = true;
                this.$nextTick(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                });
            }).catch((error) => {
            });
        },
        // キャンセル画面を閉じる
        closedCancelPage(){
            this.cancelReady = false;
            this.showReady = true;
            this.$nextTick(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        },
        // 予約一覧
        async confirmList() {
            this.confirmReady = false
            await guestReservationsService.list('paginate=1&per_page=30&actual_exit=0&status=0').then((response) => {
                this.confirm = response.data
                this.confirmReady = true
            }).catch((error) => {
            });
        },
        // 入庫一覧
        // async enteredList() {
        //     this.enteredReady = false
        //     await guestReservationsService.list('paginate=1&per_page=30&status=1').then((response) => {
        //         this.entered = response.data
        //         this.enteredReady = true
        //     }).catch((error) => {
        //     });
        // },
        // 出庫一覧
        // async exitedList() {
        //     this.exitedReady = false
        //     await guestReservationsService.list('paginate=1&per_page=30&actual_exit=1').then((response) => {
        //         this.exited = response.data
        //         this.exitedReady = true
        //     }).catch((error) => {
        //     });
        // },
        // 利用履歴
        async historyList() {
            this.historyReady = false
            await guestReservationsService.list('paginate=1&per_page=30&actual_exit=1').then((response) => {
                this.history = response.data
                this.historyReady = true
            }).catch((error) => {
            });
        },
        // キャンセル一覧
        async cancelledList() {
            this.cancelledReady = false
            await guestReservationsService.list('paginate=1&per_page=30&status=3').then((response) => {
                this.cancelled = response.data
                this.cancelledReady = true
            }).catch((error) => {
            });
        },
        showCancelModal(data) {
            this.reservation = data
            this.$bvModal.show('cancel-modal')
        },
        hideCancelModal() {
            this.reservation = {}
            this.$bvModal.hide('cancel-modal')
        },
        async cancelReservation(id) {
            alertService.loading()
            await guestReservationsService.cancel({
                reservation_id: id,
                status: this.reservation_status.cancelled,
            }).then((response) => {
                this.hideCancelModal()
                this.confirmList()
                this.cancelledList()
                this.$router.push({ path: '/guest/reservation/success', query: { type: "cancel" } });
                alertService.success(this.$t('guest.reservation.reservation-alert'), this.$t('guest.reservation.cancelled-successfully'));
                this.vTabEvent()
            }).catch((error) => {
                alertService.close()
            });
        },
    }
}
